import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignSystemModule } from '@peca/design-system';

@Component({
  selector: 'peca-kanban-load-card-skeleton ',
  imports: [CommonModule, DesignSystemModule],
  templateUrl: './kanban-load-card-skeleton.component.html',
  styleUrl: './kanban-load-card-skeleton.component.scss',
})
export class KanbanLoadSkeletonCardComponent {}
